/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_TitleInputs */

const en_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write to us.`)
};

const lv_contact_form_title = /** @type {(inputs: Contact_Form_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakstiet mums.`)
};

/**
* | output |
* | --- |
* | "Write to us." |
*
* @param {Contact_Form_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_form_title = /** @type {((inputs?: Contact_Form_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_form_title(inputs)
	return en_contact_form_title(inputs)
});